// Trigger-backup error mapping (GitHub issue #266)
//
// The backend rejects a duplicate trigger with HTTP 429 (TOO_MANY_REQUESTS)
// when a backup is already QUEUED/IN_PROGRESS (backup.service.ts:129). Deriving
// the friendly toast from that stable status code — instead of matching the
// substring "progress" in the human-readable message — keeps the UX intact if
// the backend message is reworded or localized.

import { ApiError } from '@/lib/api-client';

export function triggerBackupErrorMessage(err: unknown): string {
  if (err instanceof ApiError) {
    if (err.statusCode === 429) return 'A backup is already in progress';
    return err.message;
  }
  return 'Failed to trigger backup';
}
